import PickupLocationsSFC from "./PickupLocations.vue";
export type { IPickupLocationsEmits } from "./emits";
export type { IPickupLocationsProps } from "./props";
export const PickupLocations = PickupLocationsSFC;
